(function() {
  var MEDIDOR_STATE_STORAGE_KEY = 'beoutMedidorStateV2';
  var MEDIDOR_CONSENT_TTL = 24 * 60 * 60 * 1000;

  function removeMedidorStickyCart() {
    if (!document.querySelector('[data-medidor-flow]')) return;

    document.querySelectorAll('.sticky-cart-wrapper').forEach(function(stickyCart) {
      stickyCart.remove();
    });
  }

  function getEmptyStoredState() {
    return {
      consents: {},
      productChoices: {},
      productVariants: {},
      directSelections: {}
    };
  }

  function readStoredState() {
    try {
      var raw = window.localStorage.getItem(MEDIDOR_STATE_STORAGE_KEY);
      if (!raw) return getEmptyStoredState();

      var parsed = JSON.parse(raw);
      if (!parsed || typeof parsed !== 'object') {
        return getEmptyStoredState();
      }

      var now = Date.now();
      var nextState = getEmptyStoredState();

      ['consents', 'productChoices', 'productVariants', 'directSelections'].forEach(function(bucket) {
        var source = parsed[bucket];
        if (!source || typeof source !== 'object') return;

        Object.keys(source).forEach(function(key) {
          var entry = source[key];
          if (!entry || typeof entry !== 'object') return;
          var timestamp = Number(entry.timestamp || entry.ts || 0);
          if (!timestamp) return;
          if (now - timestamp >= MEDIDOR_CONSENT_TTL) return;
          nextState[bucket][key] = entry;
        });
      });

      writeStoredState(nextState);
      return nextState;
    } catch (error) {
      console.error(error);
      return getEmptyStoredState();
    }
  }

  function writeStoredState(state) {
    try {
      var hasEntries = Object.keys(state.consents || {}).length
        || Object.keys(state.productChoices || {}).length
        || Object.keys(state.productVariants || {}).length
        || Object.keys(state.directSelections || {}).length;

      if (!hasEntries) {
        window.localStorage.removeItem(MEDIDOR_STATE_STORAGE_KEY);
        return;
      }

      window.localStorage.setItem(MEDIDOR_STATE_STORAGE_KEY, JSON.stringify(state));
    } catch (error) {
      console.error(error);
    }
  }

  function getSavedConsentInfo(choice) {
    var data = readStoredState();
    return data.consents[choice] || null;
  }

  function getLatestConsentEntry() {
    var data = readStoredState();
    var latestChoice = '';
    var latestEntry = null;

    Object.keys(data.consents || {}).forEach(function(choice) {
      var entry = data.consents[choice];
      if (!entry || typeof entry !== 'object') return;
      var timestamp = Number(entry.timestamp || entry.ts || 0);
      if (!timestamp) return;
      if (!latestEntry || timestamp > Number(latestEntry.timestamp || latestEntry.ts || 0)) {
        latestChoice = choice;
        latestEntry = entry;
      }
    });

    if (!latestChoice || !latestEntry) return null;

    return {
      choice: latestChoice,
      entry: latestEntry
    };
  }

  function hasSavedConsent(choice) {
    return !!getSavedConsentInfo(choice);
  }

  function getSavedProductChoice(productId) {
    if (!productId) return null;
    var data = readStoredState();
    return data.productChoices[String(productId)] || null;
  }

  function saveProductChoice(productId, choice, approved) {
    if (!productId) return;
    var data = readStoredState();
    data.productChoices[String(productId)] = {
      choice: choice || '',
      approved: !!approved,
      timestamp: Date.now()
    };
    writeStoredState(data);
  }

  function clearProductChoice(productId) {
    if (!productId) return;
    var data = readStoredState();
    delete data.productChoices[String(productId)];
    writeStoredState(data);
  }

  function getSavedProductVariant(productId) {
    if (!productId) return null;
    var data = readStoredState();
    return data.productVariants[String(productId)] || null;
  }

  function saveProductVariant(productId, variantId) {
    if (!productId || !variantId) return;
    var data = readStoredState();
    data.productVariants[String(productId)] = {
      variantId: String(variantId),
      timestamp: Date.now()
    };
    writeStoredState(data);
  }

  function clearSavedProductVariant(productId) {
    if (!productId) return;
    var data = readStoredState();
    delete data.productVariants[String(productId)];
    writeStoredState(data);
  }

  function getSavedDirectSelection(productId) {
    if (!productId) return null;
    var data = readStoredState();
    return data.directSelections[String(productId)] || null;
  }

  function getLatestDirectSelection() {
    var data = readStoredState();
    var latest = data.directSelections.__latest || null;

    Object.keys(data.directSelections || {}).forEach(function(key) {
      if (key === '__latest') return;
      var entry = data.directSelections[key];
      if (!entry || typeof entry !== 'object') return;
      var timestamp = Number(entry.timestamp || entry.ts || 0);
      if (!timestamp) return;
      if (!latest || timestamp > Number(latest.timestamp || latest.ts || 0)) {
        latest = entry;
      }
    });

    return latest;
  }

  function saveDirectSelection(productId, selection) {
    if (!productId || !selection || !selection.hasValue) return;
    var data = readStoredState();
    var entry = {
      productId: String(productId),
      options: selection.options || [],
      valuesBySlug: selection.valuesBySlug || {},
      valuesByName: selection.valuesByName || {},
      timestamp: Date.now()
    };
    data.directSelections[String(productId)] = entry;
    data.directSelections.__latest = entry;
    writeStoredState(data);
  }

  function clearSavedDirectSelection(productId) {
    if (!productId) return;
    var data = readStoredState();
    delete data.directSelections[String(productId)];
    writeStoredState(data);
  }

  function saveConsent(choice, productId) {
    var data = readStoredState();
    data.consents[choice] = {
      productId: String(productId || ''),
      timestamp: Date.now()
    };
    if (productId) {
      data.productChoices[String(productId)] = {
        choice: choice || '',
        approved: true,
        timestamp: Date.now()
      };
    }
    writeStoredState(data);
  }

  function clearSavedConsents() {
    try {
      window.localStorage.removeItem(MEDIDOR_STATE_STORAGE_KEY);
    } catch (error) {
      console.error(error);
    }
  }

  function showElement(el) {
    if (!el) return;
    el.hidden = false;
    el.removeAttribute('hidden');
  }

  function hideElement(el) {
    if (!el) return;
    el.hidden = true;
    el.setAttribute('hidden', 'hidden');
  }

  function escapeHtml(value) {
    return String(value || '')
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#39;');
  }

  function openModal(modal, opener) {
    if (!modal) return;
    if (typeof modal.show === 'function') {
      modal.show(opener || document.body);
    } else {
      modal.setAttribute('open', '');
    }
  }

  function closeModal(modal) {
    if (!modal) return;
    if (typeof modal.hide === 'function') {
      modal.hide();
    } else {
      modal.removeAttribute('open');
    }
  }

  var medidorRemotePageContentCache = {};

  function loadMedidorPageContent(container) {
    if (!container || container.dataset.medidorPageLoaded === 'true' || container.dataset.medidorPageLoading === 'true') return;

    var pageUrl = container.getAttribute('data-medidor-page-url');
    if (!pageUrl) return;

    container.dataset.medidorPageLoading = 'true';

    function renderContent(html) {
      container.innerHTML = html;
      container.dataset.medidorPageLoaded = 'true';
      container.dataset.medidorPageLoading = 'false';
    }

    function renderError() {
      container.dataset.medidorPageLoading = 'false';
      container.dataset.medidorPageError = 'true';
      container.innerHTML = '<p>Não foi possível carregar as orientações completas neste pop-up. <a href="' + escapeHtml(pageUrl) + '" target="_blank" rel="noopener">Abrir a página de orientações</a>.</p>';
    }

    if (medidorRemotePageContentCache[pageUrl]) {
      renderContent(medidorRemotePageContentCache[pageUrl]);
      return;
    }

    fetch(pageUrl, {
      credentials: 'same-origin',
      headers: {
        'X-Requested-With': 'XMLHttpRequest'
      }
    })
      .then(function(response) {
        if (!response.ok) {
          throw new Error('Não foi possível carregar a página do medidor.');
        }
        return response.text();
      })
      .then(function(html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var mainContent = doc.querySelector('#MainContent');

        if (!mainContent) {
          throw new Error('Conteúdo principal da página não encontrado.');
        }

        var wrapper = doc.createElement('div');
        wrapper.className = 'medidor-flow__template-content';

        Array.prototype.slice.call(mainContent.children).forEach(function(child) {
          if (!child || child.tagName === 'SCRIPT') return;
          wrapper.appendChild(child.cloneNode(true));
        });

        wrapper.querySelectorAll('script').forEach(function(script) {
          script.remove();
        });

        var hasVisualContent = !!wrapper.querySelector('img, video, iframe, svg, deferred-media, model-viewer');
        var hasTextContent = !!String(wrapper.textContent || '').replace(/\s+/g, '').length;

        if (!hasVisualContent && !hasTextContent) {
          throw new Error('A página selecionada não possui conteúdo renderizado.');
        }

        medidorRemotePageContentCache[pageUrl] = wrapper.innerHTML;
        renderContent(medidorRemotePageContentCache[pageUrl]);
      })
      .catch(function(error) {
        console.error(error);
        renderError();
      });
  }

  function loadMedidorModalContent(modal) {
    if (!modal) return;
    modal.querySelectorAll('[data-medidor-page-content]').forEach(loadMedidorPageContent);
  }

  function getSectionRenderPayload() {
    var miniCart = document.querySelector('mini-cart');
    var sections = miniCart && typeof miniCart.getSectionsToRender === 'function'
      ? miniCart.getSectionsToRender().map(function(section) { return section.id; })
      : [];
    var sectionNames = miniCart && typeof miniCart.getSectionsToRender === 'function'
      ? miniCart.getSectionsToRender().map(function(section) { return section.section || section.id; })
      : [];

    return {
      miniCart: miniCart,
      sections: sections,
      sectionNames: sectionNames,
      sectionsUrl: window.location.pathname
    };
  }

  function refreshMiniCartSections() {
    var renderData = getSectionRenderPayload();
    if (!renderData.miniCart || !renderData.sectionNames.length) {
      return Promise.resolve(null);
    }

    var body = JSON.stringify({
      updates: {},
      sections: renderData.sectionNames,
      sections_url: renderData.sectionsUrl
    });

    return fetch(theme.routes.cart_update_url, Object.assign({}, fetchConfig(), { body: body }))
      .then(function(response) {
        return response.json();
      })
      .then(function(response) {
        if (typeof renderData.miniCart.renderContents === 'function') {
          renderData.miniCart.renderContents(response);
        }
        return response;
      });
  }

  function waitForMainItem(checkFn, attempts, delay) {
    return new Promise(function(resolve) {
      function run(remaining) {
        fetchCartJson()
          .then(function(cart) {
            if (checkFn(cart) || remaining <= 0) {
              resolve(cart);
              return;
            }
            window.setTimeout(function() {
              run(remaining - 1);
            }, delay);
          })
          .catch(function() {
            resolve(null);
          });
      }
      run(attempts);
    });
  }

  function fetchCartJson() {
    return fetch('/cart.js', { headers: { Accept: 'application/json' } }).then(function(response) {
      return response.json();
    });
  }

  function initDragTrack(track) {
    if (!track || track.dataset.dragReady === 'true') return;
    track.dataset.dragReady = 'true';

    var isPointerDown = false;
    var startX = 0;
    var startScrollLeft = 0;

    track.addEventListener('mousedown', function(event) {
      isPointerDown = true;
      startX = event.pageX;
      startScrollLeft = track.scrollLeft;
      track.classList.add('is-dragging');
    });

    window.addEventListener('mouseup', function() {
      isPointerDown = false;
      track.classList.remove('is-dragging');
    });

    window.addEventListener('mousemove', function(event) {
      if (!isPointerDown) return;
      event.preventDefault();
      track.scrollLeft = startScrollLeft - (event.pageX - startX);
    });
  }

  function initMedidorFlow(container) {
    if (!container || container.dataset.medidorInitialized === 'true') return;
    container.dataset.medidorInitialized = 'true';

    var section = container.closest('[id^="shopify-section-"]') || document;
    var productForms = section.querySelectorAll('[data-medidor-product-form]');
    if (!productForms.length) return;

    var variantPanel = section.querySelector('[data-medidor-variant-panel]');
    var submitNote = section.querySelector('[data-medidor-submit-note]');
    var inlineError = section.querySelector('[data-medidor-inline-error]');
    var hiddenRoleInputs = section.querySelectorAll('[data-medidor-role]');
    var hiddenChoiceInputs = section.querySelectorAll('[data-medidor-choice]');
    var hiddenApprovedInputs = section.querySelectorAll('[data-medidor-approved]');
    var hiddenVariantModeInputs = section.querySelectorAll('[data-medidor-variant-mode]');
    var hiddenSourceProductInputs = section.querySelectorAll('[data-medidor-source-product-id]');
    var hiddenAddonVariantInputs = section.querySelectorAll('[data-medidor-addon-variant-id]');
    var hiddenSourceHandleInputs = section.querySelectorAll('[data-medidor-source-handle]');
    var directModal = section.querySelector('[data-medidor-modal="direct"]');
    var rulerModal = section.querySelector('[data-medidor-modal="ruler"]');
    loadMedidorModalContent(rulerModal);
    loadMedidorModalContent(directModal);
    var optionButtons = container.querySelectorAll('[data-medidor-option]');
    var reviewButtons = container.querySelectorAll('[data-medidor-review]');
    var stepsBlock = section.querySelector('[data-medidor-steps]');
    var stepsTrack = stepsBlock ? stepsBlock.querySelector('.medidor-steps__track') : null;
    var quantityWrappers = section.querySelectorAll('[data-medidor-quantity-wrapper]');

    initDragTrack(stepsTrack);
    applyFlowCopy();

    var sourceProductId = container.getAttribute('data-medidor-product-id') || '';
    var addonVariantId = container.getAttribute('data-medidor-addon-variant-id') || '';
    var sourceHandle = section.querySelector('[data-medidor-source-handle]')
      ? (section.querySelector('[data-medidor-source-handle]').value || '')
      : '';
    var addonBadgeText = container.getAttribute('data-medidor-addon-badge-text') || 'Medidor enviado antes';
    var addonTooltipText = container.getAttribute('data-medidor-addon-tooltip-text') || 'Você recebe o kit medidor e, após conferir sua numeração, entra em contato com nosso suporte para informar a medida correta. Assim, garantimos o envio do seu anel no tamanho ideal.';
    var addonDetailsText = container.getAttribute('data-medidor-addon-details-text') || 'Primeiro, você recebe o kit medidor. Após identificar o tamanho ideal usando o medidor, entre em contato com o nosso suporte informando a medida correta, para que seu anel seja enviado.';
    var rememberChoiceAcrossProducts = container.getAttribute('data-remember-choice-across-products') === 'true';
    var directFeeNoteText = container.getAttribute('data-direct-fee-note') || 'Em caso de troca por tamanho, a taxa é de R$ 39,90.';

    function applyFlowCopy() {}

    var state = {
      choice: '',
      approved: false,
      opened: {
        ruler: false,
        direct: false
      },
      rulerNeedsConfirmation: false,
      directNeedsConfirmation: false,
      pendingAddon: false,
      pendingVariantId: '',
      isAddingAddon: false,
      approvedFromMemory: false,
      approvedFromAnotherProduct: false
    };


    function ensureRoleInputs() {
      productForms.forEach(function(form) {
        var roleInput = form.querySelector('[data-medidor-role]');
        if (roleInput) return;
        var hiddenInput = document.createElement('input');
        hiddenInput.type = 'hidden';
        hiddenInput.name = 'properties[_medidor_role]';
        hiddenInput.value = 'main';
        hiddenInput.setAttribute('data-medidor-role', '');
        form.appendChild(hiddenInput);
      });
      hiddenRoleInputs = section.querySelectorAll('[data-medidor-role]');
    }

    function getMainProductForm() {
      return productForms[0];
    }

    function getVariantInput(form) {
      return form ? form.querySelector('[name="id"]') : null;
    }

    function getDefaultVariantId(form) {
      var input = getVariantInput(form);
      return input ? (input.getAttribute('data-default-variant-id') || '') : '';
    }

    function getVariantController() {
      var sectionId = container.getAttribute('data-section-id');
      return section.querySelector('variant-radios[data-section="' + sectionId + '"], variant-selects[data-section="' + sectionId + '"]');
    }

    function getVariantData() {
      var controller = getVariantController();
      if (!controller) return [];
      if (typeof controller.getVariantData === 'function') {
        return controller.getVariantData() || [];
      }
      var json = controller.querySelector('[type="application/json"]');
      if (!json) return [];
      try {
        return JSON.parse(json.textContent || '[]');
      } catch (error) {
        console.error(error);
        return [];
      }
    }

    function isDeferredVariantGroup(group) {
      if (!group) return false;
      if (group.getAttribute('data-medidor-deferred-option') === 'true') return true;

      var slug = String(group.getAttribute('data-option-slug') || '').toLowerCase();
      return slug.indexOf('tamanho') !== -1
        || slug.indexOf('medida') !== -1
        || slug.indexOf('aro') !== -1
        || slug.indexOf('numeracao') !== -1
        || slug.indexOf('numera') !== -1;
    }

    function getSelectableRadio(group) {
      if (!group) return null;
      return Array.prototype.slice.call(group.querySelectorAll('input[type="radio"]')).find(function(input) {
        if (input.disabled) return false;
        if (input.classList.contains('placeholder-input')) return false;
        if (input.getAttribute('data-option-value') === 'placeholder') return false;
        if (input.getAttribute('data-medidor-ruler-option') === 'true') return false;
        return !!input.value;
      }) || null;
    }

    function ensureNonDeferredOptionsSelected() {
      var controller = getVariantController();
      if (!controller) return;

      if (controller.tagName === 'VARIANT-RADIOS') {
        Array.prototype.slice.call(controller.querySelectorAll('.variant-input-wrapper')).forEach(function(group) {
          if (isDeferredVariantGroup(group)) return;

          var checked = group.querySelector('input[type="radio"]:checked:not(.placeholder-input)');
          if (checked && checked.getAttribute('data-option-value') !== 'placeholder') return;

          var firstSelectable = getSelectableRadio(group);
          if (!firstSelectable) return;
          firstSelectable.checked = true;
          firstSelectable.dispatchEvent(new Event('change', { bubbles: true }));
        });
        return;
      }

      Array.prototype.slice.call(controller.querySelectorAll('.variant-input-wrapper')).forEach(function(group) {
        if (isDeferredVariantGroup(group)) return;
        var select = group.querySelector('select');
        if (!select || select.value) return;

        var firstOption = Array.prototype.slice.call(select.options).find(function(option) {
          return !option.disabled && option.value && option.getAttribute('data-medidor-ruler-option') !== 'true';
        });

        if (!firstOption) return;
        select.value = firstOption.value;
        select.dispatchEvent(new Event('input', { bubbles: true }));
        select.dispatchEvent(new Event('change', { bubbles: true }));
      });
    }

    function getSelectedOptions() {
      var controller = getVariantController();
      if (!controller) return [];

      ensureNonDeferredOptionsSelected();

      if (controller.tagName === 'VARIANT-RADIOS') {
        return Array.prototype.slice.call(controller.querySelectorAll('.variant-input-wrapper')).map(function(group) {
          var checked = group.querySelector('input[type="radio"]:checked');
          if (!checked) return '';
          if (checked.classList.contains('placeholder-input')) return '';
          if (checked.getAttribute('data-option-value') === 'placeholder') return '';
          return checked.value || '';
        });
      }

      return Array.prototype.slice.call(controller.querySelectorAll('.variant-input-wrapper')).map(function(group) {
        var select = group.querySelector('select');
        if (!select || !select.value) return '';
        if (isDeferredVariantGroup(group) && select.selectedIndex <= 0) return '';
        return select.value;
      });
    }

    function getCurrentDirectVariant() {
      var variants = getVariantData();
      var selectedOptions = getSelectedOptions();
      if (!variants.length || !selectedOptions.length) return null;
      if (selectedOptions.some(function(value) { return !value; })) return null;

      return variants.find(function(variant) {
        if (!variant || !variant.options) return false;
        return variant.options.every(function(optionValue, index) {
          return selectedOptions[index] === optionValue;
        });
      }) || null;
    }


    var RULER_PLACEHOLDER_VALUES = [
      'a definir',
      'a definir (será enviado depois de receber o medidor)'
    ];

    function normalizeValue(value) {
      return String(value || '').trim().toLowerCase();
    }

    function isRulerPlaceholderValue(value) {
      return RULER_PLACEHOLDER_VALUES.indexOf(normalizeValue(value)) !== -1;
    }

    function findRulerVariant() {
      var variants = getVariantData();
      if (!variants.length) return null;

      ensureNonDeferredOptionsSelected();
      var selectedOptions = getSelectedOptions();

      var matchedByCurrentOptions = variants.find(function(variant) {
        if (!variant || !variant.options) return false;
        var hasRulerOption = variant.options.some(function(optionValue) {
          return isRulerPlaceholderValue(optionValue);
        });
        if (!hasRulerOption) return false;

        return variant.options.every(function(optionValue, index) {
          if (isRulerPlaceholderValue(optionValue)) return true;
          if (!selectedOptions[index]) return true;
          return selectedOptions[index] === optionValue;
        });
      });

      if (matchedByCurrentOptions) return matchedByCurrentOptions;

      return variants.find(function(variant) {
        if (!variant || !variant.options) return false;
        return variant.options.some(function(optionValue) {
          return isRulerPlaceholderValue(optionValue);
        });
      }) || null;
    }

    function applyRulerVariantSelection() {
      ensureNonDeferredOptionsSelected();
      var controller = getVariantController();
      var rulerVariant = findRulerVariant();

      if (controller) {
        if (controller.tagName === 'VARIANT-RADIOS') {
          var rulerRadio = controller.querySelector('input[data-medidor-ruler-option="true"]');
          if (rulerRadio) {
            rulerRadio.checked = true;
            rulerRadio.dispatchEvent(new Event('change', { bubbles: true }));
          }
        } else {
          var rulerOption = controller.querySelector('option[data-medidor-ruler-option="true"]');
          if (rulerOption) {
            var select = rulerOption.closest('select');
            if (select) {
              select.value = rulerOption.value;
              select.dispatchEvent(new Event('input', { bubbles: true }));
              select.dispatchEvent(new Event('change', { bubbles: true }));
            }
          }
        }
      }

      if (rulerVariant && rulerVariant.id) {
        setVariantInputForForms(String(rulerVariant.id));
        return rulerVariant;
      }

      var form = getMainProductForm();
      setVariantInputForForms(getDefaultVariantId(form));
      return null;
    }

    function setVariantInputForForms(value) {
      productForms.forEach(function(form) {
        var input = getVariantInput(form);
        if (!input) return;
        input.value = value || '';
      });
    }

    function syncDirectVariantInput() {
      var variant = getCurrentDirectVariant();
      setVariantInputForForms(variant ? String(variant.id) : '');
      return variant;
    }

    function getInputValueFromGroup(group) {
      if (!group) return '';

      var checked = group.querySelector('input[type="radio"]:checked');
      if (checked) {
        if (checked.classList.contains('placeholder-input')) return '';
        if (checked.getAttribute('data-option-value') === 'placeholder') return '';
        return checked.value || '';
      }

      var select = group.querySelector('select');
      if (select && select.value) {
        if (isDeferredVariantGroup(group) && select.selectedIndex <= 0) return '';
        return select.value || '';
      }

      return '';
    }

    function getCurrentDirectSelection() {
      var controller = getVariantController();
      if (!controller) return null;

      var groups = Array.prototype.slice.call(controller.querySelectorAll('.variant-input-wrapper'));
      var options = [];
      var valuesBySlug = {};
      var valuesByName = {};
      var hasValue = false;

      groups.forEach(function(group, index) {
        if (!isDeferredVariantGroup(group)) return;

        var value = getInputValueFromGroup(group);
        if (!value) return;

        var slug = String(group.getAttribute('data-option-slug') || '').toLowerCase();
        var input = group.querySelector('input[type="radio"], select');
        var name = input ? String(input.getAttribute('name') || '').toLowerCase() : '';

        options[index] = value;
        if (slug) valuesBySlug[slug] = value;
        if (name) valuesByName[name] = value;
        hasValue = true;
      });

      return {
        options: options,
        valuesBySlug: valuesBySlug,
        valuesByName: valuesByName,
        hasValue: hasValue
      };
    }

    function applyDirectSelection(selection) {
      if (!selection || typeof selection !== 'object') return false;

      var controller = getVariantController();
      if (!controller) return false;

      ensureNonDeferredOptionsSelected();

      var changed = false;
      var groups = Array.prototype.slice.call(controller.querySelectorAll('.variant-input-wrapper'));

      groups.forEach(function(group, index) {
        if (!isDeferredVariantGroup(group)) return;

        var slug = String(group.getAttribute('data-option-slug') || '').toLowerCase();
        var input = group.querySelector('input[type="radio"], select');
        var name = input ? String(input.getAttribute('name') || '').toLowerCase() : '';
        var desiredValue = '';

        if (slug && selection.valuesBySlug && selection.valuesBySlug[slug]) {
          desiredValue = selection.valuesBySlug[slug];
        } else if (name && selection.valuesByName && selection.valuesByName[name]) {
          desiredValue = selection.valuesByName[name];
        } else if (selection.options && selection.options[index]) {
          desiredValue = selection.options[index];
        }

        if (!desiredValue) return;

        if (controller.tagName === 'VARIANT-RADIOS') {
          var match = Array.prototype.slice.call(group.querySelectorAll('input[type="radio"]')).find(function(radio) {
            return radio.value === desiredValue && !radio.disabled && !radio.classList.contains('placeholder-input');
          });

          if (match) {
            match.checked = true;
            match.dispatchEvent(new Event('change', { bubbles: true }));
            changed = true;
          }
        } else {
          var select = group.querySelector('select');
          if (!select) return;

          var optionExists = Array.prototype.slice.call(select.options).some(function(option) {
            return option.value === desiredValue && !option.disabled;
          });

          if (optionExists) {
            select.value = desiredValue;
            select.dispatchEvent(new Event('input', { bubbles: true }));
            select.dispatchEvent(new Event('change', { bubbles: true }));
            changed = true;
          }
        }
      });

      if (changed) {
        syncDirectVariantInput();
      }

      return changed;
    }

    function persistDirectSelection() {
      if (!(state.choice === 'direct' && state.approved)) return;

      var selectedVariant = syncDirectVariantInput();
      if (selectedVariant && selectedVariant.id) {
        saveProductVariant(sourceProductId, selectedVariant.id);
      }

      var selection = getCurrentDirectSelection();
      if (selection && selection.hasValue) {
        saveDirectSelection(sourceProductId, selection);
      }

      saveProductChoice(sourceProductId, 'direct', true);
      saveConsent('direct', sourceProductId);
    }

    function persistMedidorNavigationState() {
      if (!state.choice || !state.approved) return;

      saveProductChoice(sourceProductId, state.choice, true);
      saveConsent(state.choice, sourceProductId);

      if (state.choice === 'direct') {
        persistDirectSelection();
      }
    }

    function getSubmitButtons() {
      return Array.prototype.slice.call(section.querySelectorAll('[data-medidor-submit]'));
    }

    function hasDirectVariantSelected() {
      var variant = syncDirectVariantInput();
      return !!(variant && variant.id);
    }

    function canSubmit() {
      if (!state.choice || !state.approved) return false;
      if (state.choice === 'direct') return hasDirectVariantSelected();
      return true;
    }

    function resetVariantSelection() {
      if (!variantPanel) return;

      var controller = getVariantController();
      if (!controller) return;

      if (controller.tagName === 'VARIANT-RADIOS') {
        Array.prototype.slice.call(variantPanel.querySelectorAll('.variant-input-wrapper')).forEach(function(group) {
          var deferredGroup = isDeferredVariantGroup(group);
          var placeholderInput = group.querySelector('.placeholder-input');

          if (deferredGroup && placeholderInput) {
            placeholderInput.disabled = false;
            placeholderInput.checked = true;
          }

          Array.prototype.slice.call(group.querySelectorAll('input[type="radio"]')).forEach(function(input) {
            if (input.classList.contains('placeholder-input')) return;
            if (deferredGroup) input.checked = false;
          });

          if (!deferredGroup) {
            var firstSelectable = getSelectableRadio(group);
            if (firstSelectable) {
              firstSelectable.checked = true;
            }
          }

          var changedInput = deferredGroup && placeholderInput ? placeholderInput : group.querySelector('input[type="radio"]:checked');
          if (changedInput) changedInput.dispatchEvent(new Event('change', { bubbles: true }));
        });
        return;
      }

      Array.prototype.slice.call(variantPanel.querySelectorAll('.variant-input-wrapper')).forEach(function(group) {
        var select = group.querySelector('select');
        if (!select || !select.options.length) return;

        if (isDeferredVariantGroup(group)) {
          select.selectedIndex = 0;
        } else {
          var firstOption = Array.prototype.slice.call(select.options).find(function(option) {
            return !option.disabled && option.value && option.getAttribute('data-medidor-ruler-option') !== 'true';
          });
          if (firstOption) select.value = firstOption.value;
        }

        select.dispatchEvent(new Event('input', { bubbles: true }));
        select.dispatchEvent(new Event('change', { bubbles: true }));
      });
    }

    function syncProperties() {
      var variantMode = '';
      if (state.choice === 'ruler') {
        variantMode = 'compra-com-medidor';
      } else if (state.choice === 'direct') {
        variantMode = 'compra-sem-medidor';
      }

      ensureRoleInputs();
      hiddenRoleInputs.forEach(function(input) { input.value = 'main'; });
      hiddenChoiceInputs.forEach(function(input) { input.value = state.choice; });
      hiddenApprovedInputs.forEach(function(input) { input.value = state.approved ? 'true' : 'false'; });
      hiddenVariantModeInputs.forEach(function(input) { input.value = variantMode; });
      hiddenSourceProductInputs.forEach(function(input) { input.value = sourceProductId; });
      hiddenAddonVariantInputs.forEach(function(input) { input.value = addonVariantId; });
      hiddenSourceHandleInputs.forEach(function(input) { input.value = sourceHandle; });
    }

    function lockButtons() {
      getSubmitButtons().forEach(function(button) {
        if (button.getAttribute('data-medidor-sold-out') === 'true') return;
        button.classList.add('medidor-flow__submit--locked');
        button.classList.remove('medidor-flow__submit--ready');
        button.setAttribute('aria-disabled', 'true');
        button.disabled = false;
        button.removeAttribute('disabled');
      });
    }

    function unlockButtons() {
      getSubmitButtons().forEach(function(button) {
        if (button.getAttribute('data-medidor-sold-out') === 'true') return;
        button.classList.remove('medidor-flow__submit--locked');
        button.classList.add('medidor-flow__submit--ready');
        button.removeAttribute('aria-disabled');
        button.disabled = false;
        button.removeAttribute('disabled');
      });
    }

    function updateSubmitLabels() {
      getSubmitButtons().forEach(function(button) {
        var defaultLabel = button.getAttribute('data-default-label') || button.textContent.trim() || 'Comprar';
        if (state.choice === 'direct' && state.approved && !hasDirectVariantSelected()) {
          button.textContent = 'Selecione a medida';
        } else {
          button.textContent = defaultLabel;
        }
      });
    }

    function updateSubmitState() {
      if (canSubmit()) {
        unlockButtons();
      } else {
        lockButtons();
      }
      updateSubmitLabels();
    }

    function updateNote() {
      if (!submitNote) return;

      var safeFeeText = escapeHtml(directFeeNoteText);
      submitNote.classList.remove('medidor-flow__submit-note--warning');

      if (state.choice === 'ruler' && state.approved) {
        submitNote.innerHTML = '<span class="icon">ⓘ</span><div><strong>Envio em duas etapas</strong> Primeiro, você recebe o kit medidor. Após identificar o tamanho ideal usando o medidor, entre em contato com o nosso suporte informando a medida correta, para que seu anel seja enviado.</div>';
        showElement(submitNote);
        return;
      }

      if (state.choice === 'ruler' && state.rulerNeedsConfirmation) {
        submitNote.classList.add('medidor-flow__submit-note--warning');
        submitNote.innerHTML = '<span class="icon">!</span><div><strong>Confirmação pendente</strong> Para concluir essa compra, confirme que deseja receber o medidor primeiro. <a href="#" data-medidor-note-review="ruler">Ver orientações novamente</a>.</div>';
        showElement(submitNote);
        return;
      }

      if (state.choice === 'direct' && state.approved) {
        submitNote.innerHTML = '<span class="icon">ⓘ</span><div><strong>Medida confirmada</strong> Agora é só escolher o tamanho para continuar.</div>';
        showElement(submitNote);
        return;
      }

      if (state.choice === 'direct' && state.directNeedsConfirmation) {
        submitNote.classList.add('medidor-flow__submit-note--warning');
        submitNote.innerHTML = '<span class="icon">!</span><div><strong>Confirmação pendente</strong> Para seguir sem o medidor, confirme que você já conferiu a sua medida. <a href="#" data-medidor-note-review="direct">Ver passo a passo novamente</a>.</div>';
        showElement(submitNote);
        return;
      }

      submitNote.innerHTML = '';
      hideElement(submitNote);
    }

    function updateVariantPanel() {
      if (!variantPanel) return;
      if (state.choice === 'direct' && state.approved) {
        showElement(variantPanel);
      } else {
        hideElement(variantPanel);
      }
    }

    function updateQuantityVisibility() {
      quantityWrappers.forEach(function(wrapper) {
        if (state.choice === 'direct' && state.approved) {
          showElement(wrapper);
        } else {
          hideElement(wrapper);
          var input = wrapper.querySelector('input[name="quantity"]');
          if (input) input.value = '1';
        }
      });
    }

    function updateSteps() {
      if (!stepsBlock) return;
      if (state.choice === 'ruler') {
        showElement(stepsBlock);
      } else {
        hideElement(stepsBlock);
      }
    }

    function updateReviewButtons() {
      reviewButtons.forEach(function(button) {
        var type = button.getAttribute('data-medidor-review');
        var shouldShow = state.choice === type && !!state.opened[type];
        if (shouldShow) {
          showElement(button);
        } else {
          hideElement(button);
        }
      });
    }

    function findVariantById(variantId) {
      if (!variantId) return null;
      var variants = getVariantData();
      return variants.find(function(variant) {
        return variant && String(variant.id) === String(variantId);
      }) || null;
    }

    function applyDirectVariantById(variantId) {
      var controller = getVariantController();
      var variant = findVariantById(variantId);
      if (!controller || !variant || !variant.options) return false;

      if (controller.tagName === 'VARIANT-RADIOS') {
        var groups = controller.querySelectorAll('.variant-input-wrapper');
        variant.options.forEach(function(optionValue, index) {
          var group = groups[index];
          if (!group) return;
          var match = Array.prototype.slice.call(group.querySelectorAll('input[type="radio"]')).find(function(input) {
            return input.value === optionValue && !input.classList.contains('placeholder-input');
          });
          if (match) {
            match.checked = true;
            match.dispatchEvent(new Event('change', { bubbles: true }));
          }
        });
      } else {
        var selects = controller.querySelectorAll('select');
        variant.options.forEach(function(optionValue, index) {
          var select = selects[index];
          if (!select) return;
          select.value = optionValue;
          select.dispatchEvent(new Event('input', { bubbles: true }));
          select.dispatchEvent(new Event('change', { bubbles: true }));
        });
      }

      setVariantInputForForms(String(variant.id));
      return true;
    }

    function restoreDirectSelectionFromMemory() {
      var savedVariant = getSavedProductVariant(sourceProductId);
      if (savedVariant && savedVariant.variantId && applyDirectVariantById(savedVariant.variantId)) {
        persistDirectSelection();
        return true;
      }

      var savedSelection = getSavedDirectSelection(sourceProductId);
      if (savedSelection && applyDirectSelection(savedSelection)) {
        persistDirectSelection();
        return true;
      }

      var latestSelection = getLatestDirectSelection();
      if (latestSelection && applyDirectSelection(latestSelection)) {
        persistDirectSelection();
        return true;
      }

      syncDirectVariantInput();
      return false;
    }

    function restoreSavedProductState() {
      var savedChoice = getSavedProductChoice(sourceProductId);
      var latestConsent = getLatestConsentEntry();
      var restoredChoice = '';
      var restoredApproved = false;
      var restoredFromAnotherProduct = false;

      if (savedChoice && savedChoice.choice) {
        restoredChoice = savedChoice.choice;
        restoredApproved = !!savedChoice.approved;
        if (restoredApproved && rememberChoiceAcrossProducts) {
          var savedConsentInfo = getSavedConsentInfo(restoredChoice);
          restoredFromAnotherProduct = !!(
            savedConsentInfo
            && savedConsentInfo.productId
            && String(savedConsentInfo.productId) !== String(sourceProductId)
          );
        }
      } else if (latestConsent && latestConsent.choice) {
        restoredChoice = latestConsent.choice;
        restoredApproved = true;
        restoredFromAnotherProduct = !!(
          latestConsent.entry
          && latestConsent.entry.productId
          && String(latestConsent.entry.productId) !== String(sourceProductId)
        );
        saveProductChoice(sourceProductId, restoredChoice, true);
      }

      if (!restoredChoice) return;

      state.choice = restoredChoice;
      state.opened[restoredChoice] = true;
      state.approved = restoredApproved;
      state.approvedFromMemory = restoredApproved;
      state.approvedFromAnotherProduct = restoredFromAnotherProduct;

      if (state.choice === 'ruler') {
        applyRulerVariantSelection();
      } else if (state.choice === 'direct') {
        if (state.approved) {
          window.setTimeout(function() {
            restoreDirectSelectionFromMemory();
            refreshUI();
          }, 0);
        } else {
          setVariantInputForForms('');
        }
      }
    }

    function setActiveOption(choice) {
      optionButtons.forEach(function(button) {
        var active = button.getAttribute('data-medidor-option') === choice;
        button.classList.toggle('is-active', active);
        button.setAttribute('aria-pressed', active ? 'true' : 'false');
      });
    }

    function hideError() {
      if (!inlineError) return;
      inlineError.innerHTML = '';
      hideElement(inlineError);
    }

    function showError(message) {
      if (!inlineError) return;
      inlineError.innerHTML = '<span class="icon">!</span><div>' + message + '</div>';
      showElement(inlineError);
    }

    function refreshUI() {
      if (state.choice === 'direct' && state.approved) {
        syncDirectVariantInput();
      }
      setActiveOption(state.choice);
      syncProperties();
      updateVariantPanel();
      updateQuantityVisibility();
      updateSteps();
      updateReviewButtons();
      updateNote();
      updateSubmitState();
    }

    function selectChoice(choice) {
      if (state.choice && state.choice !== choice) {
        resetVariantSelection();
      }

      state.choice = choice;
      state.opened[choice] = true;

      var savedProductChoice = getSavedProductChoice(sourceProductId);
      var sameProductApproved = !!(
        savedProductChoice
        && savedProductChoice.choice === choice
        && savedProductChoice.approved
      );
      var consentInfo = getSavedConsentInfo(choice);
      state.approved = sameProductApproved || !!consentInfo;
      state.approvedFromMemory = state.approved;
      state.approvedFromAnotherProduct = !!(
        state.approved
        && !sameProductApproved
        && consentInfo
        && consentInfo.productId
        && String(consentInfo.productId) !== String(sourceProductId)
      );
      state.rulerNeedsConfirmation = false;
      state.directNeedsConfirmation = false;
      state.pendingAddon = false;
      state.pendingVariantId = '';
      hideError();

      saveProductChoice(sourceProductId, choice, state.approved);

      if (choice === 'ruler') {
        clearSavedProductVariant(sourceProductId);
        applyRulerVariantSelection();
      } else if (state.approved) {
        restoreDirectSelectionFromMemory();
      } else {
        setVariantInputForForms('');
      }

      refreshUI();
    }

    function queuePendingAddon() {
      state.pendingAddon = state.choice === 'ruler' && state.approved && !!addonVariantId;
      state.pendingVariantId = getVariantInput(getMainProductForm()) ? getVariantInput(getMainProductForm()).value : '';
    }

    function clearPendingAddon() {
      state.pendingAddon = false;
      state.pendingVariantId = '';
      state.isAddingAddon = false;
    }

    function buildAddonProperties() {
      return {
        _medidor_role: 'addon',
        _medidor_source_product_id: sourceProductId,
        _medidor_source_handle: sourceHandle,
        _medidor_badge_text: addonBadgeText,
        _medidor_tooltip_text: addonTooltipText,
        _medidor_details_text: addonDetailsText
      };
    }

    function addPendingAddon() {
      if (!state.pendingAddon || !addonVariantId || state.isAddingAddon) return;
      state.isAddingAddon = true;

      waitForMainItem(function(cart) {
        if (!cart || !cart.items) return false;
        return cart.items.some(function(item) {
          var props = item.properties || {};
          return props._medidor_role === 'main'
            && props._medidor_choice === 'ruler'
            && String(props._medidor_source_product_id || '') === String(sourceProductId);
        });
      }, 6, 180)
        .then(function(cart) {
          if (!cart || !cart.items) {
            return null;
          }

          var hasMain = cart.items.some(function(item) {
            var props = item.properties || {};
            return props._medidor_role === 'main'
              && props._medidor_choice === 'ruler';
          });

          var addonExists = cart.items.some(function(item) {
            var props = item.properties || {};
            return props._medidor_role === 'addon';
          });

          if (!hasMain) {
            return refreshMiniCartSections();
          }

          if (addonExists) {
            return refreshMiniCartSections();
          }

          var addonFormData = new FormData();
          addonFormData.append('id', addonVariantId);
          addonFormData.append('quantity', '1');

          var addonProperties = buildAddonProperties();
          Object.keys(addonProperties).forEach(function(key) {
            addonFormData.append('properties[' + key + ']', addonProperties[key]);
          });

          var config = fetchConfig('javascript');
          config.headers['X-Requested-With'] = 'XMLHttpRequest';
          delete config.headers['Content-Type'];
          config.body = addonFormData;

          return fetch(theme.routes.cart_add_url, config)
            .then(function(response) {
              return response.json();
            })
            .then(function(response) {
              if (response.status) {
                throw new Error(response.description || 'Não foi possível adicionar o medidor agora.');
              }

              return refreshMiniCartSections();
            })
            .then(function(response) {
              if (window.medidorCartSync && typeof window.medidorCartSync.syncAfterAdd === 'function') {
                window.setTimeout(function() {
                  window.medidorCartSync.syncAfterAdd();
                }, 120);
              }

              return response;
            });
        })
        .catch(function(error) {
          console.error(error);
        })
        .finally(function() {
          clearPendingAddon();
        });
    }

    optionButtons.forEach(function(button) {
      button.addEventListener('click', function(event) {
        if (event.target.closest('[data-medidor-review]')) return;
        var choice = button.getAttribute('data-medidor-option');
        if (!choice) return;
        state.opened[choice] = true;
        selectChoice(choice);
        if (!state.approved) {
          var choiceModal = choice === 'ruler' ? rulerModal : directModal;
          loadMedidorModalContent(choiceModal);
          openModal(choiceModal, button);
        }
      });
    });

    reviewButtons.forEach(function(button) {
      function handleReview(event) {
        event.preventDefault();
        event.stopPropagation();
        var modalType = button.getAttribute('data-medidor-review');
        if (modalType === 'ruler') {
          state.rulerNeedsConfirmation = false;
        } else {
          state.directNeedsConfirmation = false;
        }
        refreshUI();
        var reviewModal = modalType === 'ruler' ? rulerModal : directModal;
        loadMedidorModalContent(reviewModal);
        openModal(reviewModal, button);
      }

      button.addEventListener('click', handleReview);
      button.addEventListener('keydown', function(event) {
        if (event.key === 'Enter' || event.key === ' ') {
          handleReview(event);
        }
      });
    });

    section.querySelectorAll('[data-medidor-confirm]').forEach(function(button) {
      button.addEventListener('click', function() {
        var confirmType = button.getAttribute('data-medidor-confirm');
        state.choice = confirmType;
        state.approved = true;
        state.approvedFromMemory = false;
        state.approvedFromAnotherProduct = false;
        state.rulerNeedsConfirmation = false;
        state.directNeedsConfirmation = false;
        saveConsent(confirmType, sourceProductId);
        saveProductChoice(sourceProductId, confirmType, true);
        hideError();

        if (confirmType === 'ruler') {
          applyRulerVariantSelection();
          closeModal(rulerModal);
        } else {
          closeModal(directModal);
          syncDirectVariantInput();
          persistDirectSelection();
        }

        refreshUI();
      });
    });

    productForms.forEach(function(form) {
      form.addEventListener('submit', function(event) {
        hideError();

        if (!canSubmit()) {
          event.preventDefault();
          event.stopPropagation();
          event.stopImmediatePropagation();
          if (!state.choice) {
            showError('Escolha uma opção antes de continuar.');
          } else if (!state.approved) {
            showError('Abra as instruções da opção escolhida e clique em continuar.');
          } else if (state.choice === 'direct' && !hasDirectVariantSelected()) {
            showError('Selecione a medida antes de adicionar ao carrinho.');
          }
          return;
        }

        if (state.choice === 'ruler') {
          queuePendingAddon();
        } else {
          clearPendingAddon();
        }
      }, true);

      var submitButton = form.querySelector('[name="add"]');
      if (submitButton) {
        submitButton.addEventListener('click', function(event) {
          if (canSubmit()) return;
          event.preventDefault();
          event.stopPropagation();
          if (!state.choice) {
            showError('Escolha uma opção antes de continuar.');
          } else if (!state.approved) {
            showError('Abra as instruções da opção escolhida e clique em continuar.');
          } else if (state.choice === 'direct' && !hasDirectVariantSelected()) {
            showError('Selecione a medida antes de adicionar ao carrinho.');
          }
        });
      }
    });

    document.addEventListener('variant:change', function() {
      if (state.choice === 'direct' && state.approved) {
        persistDirectSelection();
      }
      refreshUI();
    });

    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      subscribe(PUB_SUB_EVENTS.cartUpdate, function(event) {
        if (!state.pendingAddon || !addonVariantId) return;
        if (!event || event.source !== 'product-form') return;
        if (state.pendingVariantId && event.productVariantId && String(state.pendingVariantId) !== String(event.productVariantId)) return;
        addPendingAddon();
      });

      subscribe(PUB_SUB_EVENTS.cartError, function(event) {
        if (!state.pendingAddon) return;
        if (!event || event.source !== 'product-form') return;
        if (state.pendingVariantId && event.productVariantId && String(state.pendingVariantId) !== String(event.productVariantId)) return;
        clearPendingAddon();
      });
    }

    if (submitNote) {
      submitNote.addEventListener('click', function(event) {
        var reviewLink = event.target.closest('[data-medidor-note-review]');
        if (!reviewLink) return;
        event.preventDefault();
        var modalType = reviewLink.getAttribute('data-medidor-note-review');
        if (modalType === 'ruler') {
          state.rulerNeedsConfirmation = false;
        } else {
          state.directNeedsConfirmation = false;
        }
        refreshUI();
        var noteModal = modalType === 'ruler' ? rulerModal : directModal;
        loadMedidorModalContent(noteModal);
        openModal(noteModal, reviewLink);
      });
    }

    section.addEventListener('click', function(event) {
      var link = event.target.closest ? event.target.closest('.variant-products-images__item[href]') : null;
      if (!link || !section.contains(link)) return;
      persistMedidorNavigationState();
    }, true);

    window.addEventListener('pagehide', persistMedidorNavigationState);

    function handleRulerDismiss() {
      if (state.choice !== 'ruler' || state.approved) return;
      state.rulerNeedsConfirmation = true;
      refreshUI();
    }

    function handleDirectDismiss() {
      if (state.choice !== 'direct' || state.approved) return;
      state.directNeedsConfirmation = true;
      refreshUI();
    }

    if (rulerModal) {
      var rulerCloseButton = rulerModal.querySelector('[id^="ModalClose-"]');
      if (rulerCloseButton) {
        rulerCloseButton.addEventListener('click', function() {
          window.setTimeout(handleRulerDismiss, 0);
        });
      }

      rulerModal.addEventListener('click', function(event) {
        if (event.target === rulerModal) {
          window.setTimeout(handleRulerDismiss, 0);
        }
      });

      rulerModal.addEventListener('keyup', function(event) {
        var key = event.code ? event.code.toUpperCase() : (event.key || '').toUpperCase();
        if (key === 'ESCAPE') {
          window.setTimeout(handleRulerDismiss, 0);
        }
      });
    }

    if (directModal) {
      var directCloseButton = directModal.querySelector('[id^="ModalClose-"]');
      if (directCloseButton) {
        directCloseButton.addEventListener('click', function() {
          window.setTimeout(handleDirectDismiss, 0);
        });
      }

      directModal.addEventListener('click', function(event) {
        if (event.target === directModal) {
          window.setTimeout(handleDirectDismiss, 0);
        }
      });

      directModal.addEventListener('keyup', function(event) {
        var key = event.code ? event.code.toUpperCase() : (event.key || '').toUpperCase();
        if (key === 'ESCAPE') {
          window.setTimeout(handleDirectDismiss, 0);
        }
      });
    }

    if (variantPanel) {
      variantPanel.addEventListener('change', function() {
        window.setTimeout(function() {
          if (state.choice === 'direct' && state.approved) {
            persistDirectSelection();
          }
          refreshUI();
        }, 0);
      });
    }

    window.addEventListener('medidor:consent-reset', function() {
      clearSavedConsents();
      state.approved = false;
      state.approvedFromMemory = false;
      state.rulerNeedsConfirmation = false;
      state.directNeedsConfirmation = false;
      if (state.choice === 'ruler') {
        applyRulerVariantSelection();
      } else if (state.choice === 'direct') {
        setVariantInputForForms('');
        resetVariantSelection();
      }
      clearSavedProductVariant(sourceProductId);
      clearSavedDirectSelection(sourceProductId);
      clearProductChoice(sourceProductId);
      refreshUI();
    });

    restoreSavedProductState();
    refreshUI();
  }

  document.addEventListener('DOMContentLoaded', function() {
    removeMedidorStickyCart();
    document.querySelectorAll('[data-medidor-flow]').forEach(initMedidorFlow);
  });

  document.addEventListener('shopify:section:load', function(event) {
    var container = event.target;
    if (!container) return;
    removeMedidorStickyCart();
    container.querySelectorAll('[data-medidor-flow]').forEach(initMedidorFlow);
  });
})();
